function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 43.0149C48 45.7763 45.7614 48.0149 43 48.0149H5C2.23858 48.0149 0 45.7763 0 43.0149V5.01489C0 2.25347 2.23858 0.0148926 5 0.0148926H43C45.7614 0.0148926 48 2.25347 48 5.01489V43.0149ZM43 1.01489H5C2.79086 1.01489 1 2.80575 1 5.01489V23.0149L47 23.0149V5.01489C47 2.80575 45.2091 1.01489 43 1.01489ZM1 24.0149V43.0149C1 45.224 2.79086 47.0149 5 47.0149H24L24 24.0149L1 24.0149ZM25 24.0149L25 47.0149H43C45.2091 47.0149 47 45.224 47 43.0149V24.0149L25 24.0149Z",
  fill: "#C1C6C9"
});

var Svg3B = function Svg3B(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3B, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3b.ff7031d4.svg";
export { ForwardRef as ReactComponent };